import { Modal } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { FieldValues } from 'react-hook-form';
import DynamicForm from '../../../../components/DynamicForm/DynamicForm';

interface DynamicFormModalProps {
  isOpen: boolean;
  certificateTypeCode: string;
  certificateTitle: string;
  onSubmit: (formData: Record<string, any>) => void;
  onCancel: () => void;
  studyPlanEnrollmentId: number;
}

export default function DynamicFormModal({
  isOpen,
  certificateTypeCode,
  certificateTitle,
  onSubmit,
  onCancel,
  studyPlanEnrollmentId,
}: DynamicFormModalProps) {
  const { t } = useTranslation();

  const handleFormSubmit = async (data: FieldValues) => {
    onSubmit(data as Record<string, any>);
  };

  return (
    <Modal isOpen={isOpen} toggle={onCancel} size="md">
      <div className="text-dark text-center fs-20">
        {t('reports.dynamicForm.title')}
        {certificateTitle}
      </div>
      <DynamicForm
        source="student-reports-modal"
        certificateTypeCode={certificateTypeCode}
        onSubmit={handleFormSubmit}
        onCancel={onCancel}
        isModalRender={true}
        studyPlanEnrollmentId={studyPlanEnrollmentId}
      />
    </Modal>
  );
}
